const adjectives = [
  "Adorable",
  "Adventurous",
  "Aggressive",
  "Agreeable",
  "Alert",
  "Alive",
  "Amused",
  "Angry",
  "Annoyed",
  "Annoying",
  "Anxious",
  "Arrogant",
  "Ashamed",
  "Attractive",
  "Average",
  "Awful",
  "Bad",
  "Beautiful",
  "Better",
  "Bewildered",
  "Black",
  "Bloody",
  "Blue",
  "Blue - Eyed",
  "Blushing",
  "Bored",
  "Brainy",
  "Brave",
  "Breakable",
  "Bright",
  "Busy",
  "Calm",
  "Careful",
  "Cautious",
  "Charming",
  "Cheerful",
  "Clean",
  "Clear",
  "Clever",
  "Cloudy",
  "Clumsy",
  "Colorful",
  "Combative",
  "Comfortable",
  "Concerned",
  "Condemned",
  "Confused",
  "Cooperative",
  "Courageous",
  "Crazy",
  "Creepy",
  "Crowded",
  "Cruel",
  "Curious",
  "Cute",
  "Dangerous",
  "Dark",
  "Dead",
  "Defeated",
  "Defiant",
  "Delightful",
  "Depressed",
  "Determined",
  "Different",
  "Difficult",
  "Disgusted",
  "Distinct",
  "Disturbed",
  "Dizzy",
  "Doubtful",
  "Drab",
  "Dull",
  "Eager",
  "Easy",
  "Elated",
  "Elegant",
  "Embarrassed",
  "Enchanting",
  "Encouraging",
  "Energetic",
  "Enthusiastic",
  "Envious",
  "Evil",
  "Excited",
  "Expensive",
  "Exuberant",
  "Fair",
  "Faithful",
  "Famous",
  "Fancy",
  "Fantastic",
  "Fierce",
  "Filthy",
  "Fine",
  "Foolish",
  "Fragile",
  "Frail",
  "Frantic",
  "Friendly",
  "Frightened",
  "Funny",
  "Gentle",
  "Gifted",
  "Glamorous",
  "Gleaming",
  "Glorious",
  "Good",
  "Gorgeous",
  "Graceful",
  "Grieving",
  "Grotesque",
  "Grumpy",
  "Handsome",
  "Happy",
  "Healthy",
  "Helpful",
  "Helpless",
  "Hilarious",
  "Homeless",
  "Homely",
  "Horrible",
  "Hungry",
  "Hurt",
  "Ill",
  "Important",
  "Impossible",
  "Inexpensive",
  "Innocent",
  "Inquisitive",
  "Itchy",
  "Jealous",
  "Jittery",
  "Jolly",
  "Joyous",
  "Kind",
  "Lazy",
  "Light",
  "Lively",
  "Lonely",
  "Long",
  "Lovely",
  "Lucky",
  "Magnificent",
  "Misty",
  "Modern",
  "Motionless",
  "Muddy",
  "Mushy",
  "Mysterious",
  "Nasty",
  "Naughty",
  "Nervous",
  "Nice",
  "Nutty",
  "Obedient",
  "Obnoxious",
  "Odd",
  "Old-fashioned",
  "Open",
  "Outrageous",
  "Outstanding",
  "Panicky",
  "Perfect",
  "Plain",
  "Pleasant",
  "Poised",
  "Poor",
  "Powerful",
  "Precious",
  "Prickly",
  "Proud",
  "Putrid",
  "Puzzled",
  "Quaint",
  "Real",
  "Relieved",
  "Repulsive",
  "Rich",
  "Scary",
  "Selfish",
  "Shiny",
  "Shy",
  "Silly",
  "Sleepy",
  "Smiling",
  "Smoggy",
  "Sore",
  "Sparkling",
  "Splendid",
  "Spotless",
  "Stormy",
  "Super",
  "Talented",
  "Tame",
  "Tasty",
  "Tender",
  "Tense",
  "Terrible",
  "Thankful",
  "Thoughtful",
  "Thoughtless",
  "Tired",
  "Tough",
  "Troubled",
  "Ugliest",
  "Ugly",
  "Uninterested",
  "Unsightly",
  "Unusual",
  "Upset",
  "Uptight",
  "Vast",
  "Victorious",
  "Vivacious",
  "Wandering",
  "Weary",
  "Wicked",
  "Wide-eyed",
  "Wild",
  "Witty",
  "Worried",
  "Worrisome",
  "Wrong",
  "Zany",
  "Zealous",
];
const animals = [
  "Aardvark",
  "Abyssinian",
  "Affenpinscher",
  "Akbash",
  "Akita",
  "Albatross",
  "Alligator",
  "Alpaca",
  "Anchovies",
  "Angelfish",
  "Ant",
  "Anteater",
  "Antelope",
  "Arapaima",
  "Armadillo",
  "Aurochs",
  "Avocet",
  "Axolotl",
  "Baboon",
  "Badger",
  "Baiji",
  "Balinese",
  "Bandicoot",
  "Barb",
  "Barnacle",
  "Barracuda",
  "Bat",
  "Beagle",
  "Bear",
  "Beaver",
  "Beetle",
  "Bichir",
  "Binturong",
  "Bird",
  "Birman",
  "Bison",
  "Blobfish",
  "Bloodhound",
  "Bobcat",
  "Bombay",
  "Bongo",
  "Bonobo",
  "Booby",
  "Bowfin",
  "Budgerigar",
  "Buffalo",
  "Bulldog",
  "Bullfrog",
  "Bullmastiff",
  "Bumblebee",
  "Burmese",
  "Butterfly",
  "Caiman",
  "Camel",
  "Capybara",
  "Caracal",
  "Carp",
  "Cassowary",
  "Cat",
  "Caterpillar",
  "Catfish",
  "Centipede",
  "Chameleon",
  "Chamois",
  "Cheetah",
  "Chicken",
  "Chihuahua",
  "Chimaera",
  "Chimpanzee",
  "Chinchilla",
  "Chinook",
  "Chipmunk",
  "Cichlid",
  "Clownfish",
  "Coati",
  "Cockatoo",
  "Cockroach",
  "Coelacanth",
  "Collie",
  "Coral",
  "Cougar",
  "Cow",
  "Coyote",
  "Crab",
  "Crane",
  "Crocodile",
  "Cuscus",
  "Cuttlefish",
  "Dachshund",
  "Dalmatian",
  "Deer",
  "Dhole",
  "Dingo",
  "Discus",
  "Dodo",
  "Dog",
  "Dolphin",
  "Donkey",
  "Dormouse",
  "Dragonfish",
  "Dragonfly",
  "Drever",
  "Duck",
  "Dugong",
  "Dunker",
  "Eagle",
  "Earwig",
  "Echidna",
  "Eel",
  "Elephant",
  "Emu",
  "Ermine",
  "Falcon",
  "Fangtooth",
  "Ferret",
  "Fish",
  "Flamingo",
  "Flounder",
  "Fly",
  "Fossa",
  "Fox",
  "Frigatebird",
  "Frog",
  "Gar",
  "Gecko",
  "Gerbil",
  "Gharial",
  "Gibbon",
  "Giraffe",
  "Goat",
  "Goose",
  "Gopher",
  "Gorilla",
  "Grasshopper",
  "Greyhound",
  "Grouse",
  "Guppy",
  "Hagfish",
  "Hamster",
  "Hare",
  "Harrier",
  "Havanese",
  "Hedgehog",
  "Heron",
  "Herring",
  "Himalayan",
  "Hippopotamus",
  "Hoopoe",
  "Hornbill",
  "Horse",
  "Human",
  "Hummingbird",
  "Hyena",
  "Ibis",
  "Iguana",
  "Impala",
  "Indri",
  "Insects",
  "Jackal",
  "Jaguar",
  "Javanese",
  "Jellyfish",
  "Jerboa",
  "Kakapo",
  "Kangaroo",
  "Keeshond",
  "Kingfisher",
  "Kiwi",
  "Koala",
  "Krill",
  "Kudu",
  "Labradoodle",
  "Ladybug",
  "Lamprey",
  "Lemming",
  "Lemur",
  "Leopard",
  "Liger",
  "Lion",
  "Lionfish",
  "Lizard",
  "Llama",
  "Lobster",
  "Lungfish",
  "Lynx",
  "Macaw",
  "Magpie",
  "Maltese",
  "Mammals",
  "Manatee",
  "Mandrill",
  "Markhor",
  "Marmot",
  "Mastiff",
  "Mayfly",
  "Meerkat",
  "Megalodon",
  "Milkfish",
  "Millipede",
  "Mink",
  "Mole",
  "Molly",
  "Mongoose",
  "Mongrel",
  "Monkey",
  "Monkfish",
  "Moorhen",
  "Moose",
  "Moth",
  "Mouse",
  "Mule",
  "Muskrat",
  "Narwhal",
  "Neanderthal",
  "Newfoundland",
  "Newt",
  "Nightingale",
  "Numbat",
  "Ocelot",
  "Octopus",
  "Okapi",
  "Olm",
  "Opossum",
  "Orang-utan",
  "Ostrich",
  "Otter",
  "Oyster",
  "Paddlefish",
  "Pademelon",
  "Pangolin",
  "Panther",
  "Parrot",
  "Peacock",
  "Pekingese",
  "Pelican",
  "Penguin",
  "Persian",
  "Pheasant",
  "Pig",
  "Pika",
  "Piranha",
  "Platypus",
  "Pointer",
  "Poodle",
  "Porcupine",
  "Porpoise",
  "Possum",
  "Prawn",
  "Pufferfish",
  "Puffin",
  "Pug",
  "Puma",
  "Quail",
  "Quetzal",
  "Quokka",
  "Quoll",
  "Rabbit",
  "Raccoon",
  "Ragdoll",
  "Rat",
  "Rattlesnake",
  "Reindeer",
  "Rhinoceros",
  "Robin",
  "Rockfish",
  "Rottweiler",
  "Sable",
  "Saiga",
  "Salamander",
  "Salmon",
  "Samoyed",
  "Saola",
  "Sardines",
  "Sawfish",
  "Scorpion",
  "Seahorse",
  "Seal",
  "Serval",
  "Shark",
  "Sheep",
  "Shrimp",
  "Siamese",
  "Siberian",
  "Skunk",
  "Sloth",
  "Snail",
  "Snake",
  "Snowshoe",
  "Somali",
  "Sparrow",
  "Sponge",
  "Squid",
  "Squirrel",
  "Starfish",
  "Stingray",
  "Stoat",
  "Sturgeon",
  "Swan",
  "Tamaskan",
  "Tang",
  "Tapir",
  "Tarpon",
  "Tarsier",
  "Termite",
  "Tetra",
  "Tiffany",
  "Tiger",
  "Tortoise",
  "Toucan",
  "Tropicbird",
  "Tuatara",
  "Turkey",
  "Uakari",
  "Uguisu",
  "Umbrellabird",
  "Utonagan",
  "Vaquita",
  "Vulture",
  "Wallaby",
  "Walrus",
  "Warthog",
  "Wasp",
  "Weasel",
  "Whippet",
  "Wildebeest",
  "Wolf",
  "Wolffish",
  "Wolverine",
  "Wombat",
  "Woodlouse",
  "Woodpecker",
  "Wrasse",
  "Xerus",
  "Yak",
  "Zebra",
  "Zebu",
  "Zonkey",
  "Zorse",
];

const randomChoice = (array) => {
  const index = Math.floor(Math.random() * array.length);
  return array[index];
};

export default function sillyNameGenerator() {
  return randomChoice(adjectives) + " " + randomChoice(animals);
}
